import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoajantaelloratour() {



const cardData = {
  keyword: " Mumbai to Ajanta Ellora Tour Package ",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai to Ajanta Ellora tour package cab services, offering hassle-free travel for families, groups, and history enthusiasts. Our professional drivers, well-maintained vehicles, and punctual pickups make exploring the UNESCO World Heritage sites of Ajanta and Ellora convenient and enjoyable. The journey covers approximately 335–350 km via the Mumbai–Aurangabad Highway, typically taking 6–7 hours depending on traffic conditions. We offer flexible booking options including one-way trips, round trips, and customized tour packages with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Mumbai to Ajanta Ellora tour cab services.",

topPlaces: [
  {
    title: "Ajanta Caves",
    description: "Ajanta Caves are ancient rock-cut Buddhist monuments famous for intricate murals, sculptures, and paintings. Travelers from Mumbai can reach the caves comfortably by cab and explore the artistic heritage, enjoying guided tours and photography opportunities. The site offers insights into 2nd-century BCE Indian culture and Buddhism."
  },
  {
    title: "Ellora Caves",
    description: "Ellora Caves is a remarkable UNESCO World Heritage site featuring Buddhist, Hindu, and Jain rock-cut temples. Visitors traveling from Mumbai can explore these historical caves by cab, admire the intricate carvings, and learn about the religious and architectural significance of the site."
  },
  {
    title: "Bibi Ka Maqbara",
    description: "Bibi Ka Maqbara, also known as the ‘Mini Taj Mahal,’ is a historic mausoleum in Aurangabad. Travelers from Mumbai can visit comfortably by cab, appreciate its Mughal architecture, and enjoy photography in the serene surroundings."
  },
  {
    title: "Daulatabad Fort",
    description: "Daulatabad Fort is a historic hill fort near Aurangabad with strategic architecture and panoramic views. Travelers using a cab from Mumbai can explore the fort, enjoy trekking trails, and capture scenic photographs of the surrounding landscape."
  },
  {
    title: "Aurangabad Caves",
    description: "Aurangabad Caves are a set of ancient Buddhist rock-cut caves near Aurangabad. Visitors traveling by cab from Mumbai can explore the historic carvings, enjoy the peaceful environment, and learn about early Buddhist architecture and art."
  },
  {
    title: "Grishneshwar Temple",
    description: "Grishneshwar Temple is a sacred Hindu temple near Ellora, dedicated to Lord Shiva. Travelers from Mumbai can visit the temple by cab, admire its intricate carvings, and participate in rituals and spiritual activities."
  },
  {
    title: "Panchakki",
    description: "Panchakki is an ancient water mill in Aurangabad with historical significance. Visitors using a cab from Mumbai can explore its engineering marvel, stroll through landscaped gardens, and learn about its unique water management system."
  },
  {
    title: "Siddharth Garden & Zoo",
    description: "Siddharth Garden & Zoo in Aurangabad offers recreational spaces, animal exhibits, and green areas. Travelers from Mumbai can enjoy a comfortable cab ride, spend leisure time amidst nature, and explore wildlife attractions."
  },
  {
    title: "Himroo Factory",
    description: "Himroo Factory is known for traditional Himroo textiles and crafts. Travelers from Mumbai using cab services can visit the factory, shop for authentic products, and experience local artistry and craftsmanship."
  },
  {
    title: "Salim Ali Lake",
    description: "Salim Ali Lake is a scenic spot in Aurangabad ideal for birdwatching, photography, and peaceful walks. Visitors traveling by cab from Mumbai can enjoy the tranquil environment and capture memorable moments amid nature."
  }
],



services: [
{
name: "Mumbai to Ajanta Ellora Cab Package",
description: "Mumbai to Ajanta Ellora cab package offers a complete and comfortable travel solution for exploring the world-famous UNESCO heritage sites in Aurangabad. This package is ideal for tourists, families, and history lovers who want a well-planned road trip covering Ajanta Caves, Ellora Caves, and nearby attractions. The journey from Mumbai to Aurangabad is smooth with well-connected highways, ensuring a relaxed travel experience. Professional drivers with knowledge of tourist routes ensure safe and guided travel throughout the trip. Customers can choose from sedan, SUV, and luxury vehicles based on their comfort and group size. Flexible itinerary options allow travelers to explore at their own pace. With transparent pricing, easy booking, and 24x7 availability, this package ensures a memorable and hassle-free travel experience."
},
{
name: "Ajanta Ellora Tour from Mumbai by Cab",
description: "Ajanta Ellora tour from Mumbai by cab provides a convenient and personalized way to explore historical monuments and cultural heritage sites. This service is perfect for travelers who prefer private travel with flexible schedules. The tour includes comfortable travel, sightseeing stops, and experienced drivers familiar with tourist destinations. Vehicles are well-maintained for long-distance travel. Travelers can enjoy a relaxed journey with planned breaks and sightseeing opportunities. It ensures a smooth and enriching travel experience."
},
{
name: "Mumbai to Ajanta Ellora Taxi Package",
description: "Mumbai to Ajanta Ellora taxi package offers a structured and comfortable travel plan for visiting Ajanta and Ellora caves. This package includes pickup, drop, and sightseeing options with flexible scheduling. Customers can select vehicle types based on their preferences and group size. Professional drivers ensure safe and smooth travel across highways. Transparent pricing ensures no hidden charges. It is ideal for family trips and group tours. It provides a complete travel solution."
},
{
name: "Ajanta Ellora Tour Cab Service Mumbai",
description: "Ajanta Ellora tour cab service Mumbai provides reliable transportation for travelers planning a historical and cultural tour. This service includes comfortable vehicles, experienced drivers, and flexible travel plans. Travelers can explore multiple destinations including Ajanta, Ellora, and nearby attractions at their own pace. Vehicles are equipped for long-distance travel ensuring comfort. Professional service ensures safety and timely travel. It offers a hassle-free sightseeing experience."
},
{
name: "Mumbai to Ajanta Ellora Cab Booking",
description: "Mumbai to Ajanta Ellora cab booking allows customers to easily reserve their tour cab with instant confirmation and flexible travel dates. Travelers can choose vehicle type, pickup location, and travel itinerary according to their needs. Transparent pricing ensures clarity in all charges. Online booking platforms provide secure payment options. Dedicated support is available for assistance. It is the easiest way to plan a heritage tour from Mumbai."
},
{
name: "Ajanta Ellora Tour by Taxi Mumbai",
description: "Ajanta Ellora tour by taxi Mumbai offers a comfortable and flexible way to explore the famous caves and historical sites. This service is ideal for travelers who prefer private travel with customized itineraries. Professional drivers ensure safe and smooth travel throughout the journey. Vehicles are well-maintained and suitable for long-distance trips. Flexible travel schedules allow better sightseeing experience. It ensures a convenient and enjoyable tour."
},
{
name: "Private Cab Ajanta Ellora Tour Mumbai",
description: "Private cab Ajanta Ellora tour Mumbai offers a personalized travel experience with exclusive vehicle usage for families and groups. Travelers can customize routes, sightseeing stops, and travel schedules according to their preferences. This ensures a relaxed and stress-free journey. Professional drivers provide safe and reliable service throughout the trip. Comfortable seating enhances the travel experience. It is ideal for private and premium tours. It guarantees flexibility and comfort."
},
{
name: "Cheap Ajanta Ellora Cab Package",
description: "Cheap Ajanta Ellora cab package offers budget-friendly travel options for tourists who want to explore heritage sites without overspending. This service provides economical vehicle options with transparent pricing. Despite affordable rates, comfort and safety are maintained. Professional drivers ensure smooth and reliable travel. Flexible booking options allow easy planning. It is a perfect choice for budget-conscious travelers. It combines affordability with convenience."
},
{
name: "Mumbai to Ajanta Ellora Outstation Cab",
description: "Mumbai to Ajanta Ellora outstation cab service provides reliable long-distance travel with comfortable vehicles and experienced drivers. This service is ideal for tourists, families, and group travelers. Flexible options include one way and round trip packages with sightseeing coverage. Vehicles are well-maintained for highway travel. Professional drivers ensure safe navigation and timely service. It ensures a hassle-free and enjoyable travel experience. It is a trusted option for heritage tours."
}
],

tableData: [
["Mumbai to Ajanta Ellora Cab Package","Ajanta Ellora Tour from Mumbai by Cab"],
["Mumbai to Ajanta Ellora Taxi Package","Ajanta Ellora Tour Cab Service Mumbai"],
["Mumbai to Ajanta Ellora Cab Booking","Ajanta Ellora Tour by Taxi Mumbai"],
["Private Cab Ajanta Ellora Tour Mumbai","Cheap Ajanta Ellora Cab Package"],
["Mumbai to Ajanta Ellora Outstation Cab","Mumbai to Ajanta Ellora Cab Package"]
],


whychoose: [
  {
    WhyChooseheading: "Complete Heritage Tour Experience",
    WhyChoosedescription: "Velocity Cabs offers Mumbai to Ajanta Ellora tour packages designed for a comfortable and enriching journey to explore world-famous UNESCO heritage sites with ease."
  },
  {
    WhyChooseheading: "Experienced Long Route Drivers",
    WhyChoosedescription: "Our drivers are highly experienced on Mumbai to Aurangabad routes and nearby tourist circuits, ensuring safe driving and smooth travel throughout the tour."
  },
  {
    WhyChooseheading: "Transparent Tour Package Pricing",
    WhyChoosedescription: "Velocity Cabs provides clear and transparent pricing for Ajanta Ellora tour packages from Mumbai, including travel cost, toll charges, and driver allowance with no hidden fees."
  },
  {
    WhyChooseheading: "Flexible Multi-Day Tour Plans",
    WhyChoosedescription: "We offer flexible tour options including 2-day, 3-day, and customized travel plans covering Ajanta Caves, Ellora Caves, Bibi Ka Maqbara, and other nearby attractions."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and regularly cleaned to ensure a comfortable long-distance and sightseeing experience."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for families, groups, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, railway stations, and airports across Mumbai for a seamless start to your Ajanta Ellora tour."
  },
  {
    WhyChooseheading: "Trusted Tour Travel Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Mumbai to Ajanta Ellora tour packages due to professional drivers, comfortable vehicles, and well-planned itineraries."
  }
]
};

const faqData = [
  { question: "Do you provide Mumbai to Ajanta Ellora tour package?", answer: "Yes, Velocity Cabs provides complete tour packages from Mumbai to Ajanta and Ellora caves." },
  { question: "How many days are required for Ajanta Ellora tour?", answer: "Typically, 2 to 3 days are required to comfortably cover Ajanta Caves, Ellora Caves, and nearby attractions." },
  { question: "What is included in the tour package?", answer: "Our packages include cab travel, driver charges, tolls, and customizable sightseeing plans." },
  { question: "Which vehicles are available for the tour?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I customize the tour itinerary?", answer: "Yes, we provide fully customizable tour plans based on your travel needs." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book the tour package online?", answer: "Yes, customers can easily book Mumbai to Ajanta Ellora tour packages online or through phone booking." },
  { question: "Do you provide hotel booking?", answer: "Hotel booking can be arranged on request as part of the tour package." },
  { question: "Is advance booking required?", answer: "Yes, advance booking is recommended especially during peak tourist seasons." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kunal Deshmukh",
    feedback:
      "A comfortable and well-managed journey from Mumbai to Ajanta Ellora. The cab was clean, the drive was smooth, and the long trip felt relaxed throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Kulkarni",
    feedback:
      "The Mumbai to Ajanta Ellora travel experience was excellent. The vehicle was well-maintained, the ride was steady, and everything was handled in a professional manner.",
    rating: 5
  }
];






















const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const mumbaiAjantaElloraTourJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Mumbai to Ajanta Ellora Tour Package | Velocity Cabs",
  "description": "Book a private cab from Mumbai for an Ajanta Ellora tour. AC, Sedan, and SUV taxis available for comfortable one-way or round trips at affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mumbai, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Mumbai to Ajanta Ellora Tour Cab Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One Way Cab for Mumbai to Ajanta Ellora Tour",
        "description": "Private cab from Mumbai to Ajanta Ellora for one-way travel with AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Mumbai to Ajanta Ellora Tour Cab",
        "description": "Comfortable round-trip cab service from Mumbai to Ajanta Ellora with private AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};




  return (
    <div>
      
<Helmet>
  <title>Mumbai to Ajanta Ellora Tour Package | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book a private cab from Mumbai for an Ajanta Ellora tour. AC, Sedan, and SUV taxis available for comfortable one-way or round trips at affordable fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(mumbaiAjantaElloraTourJSON)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/98.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoajantaelloratour;